<div class="page-layout-container">
  <div class="row">
    <h1 class="title">All Assets</h1>
  </div>

  <div class="table-card">
    <div class="table-toolbar">
      <mat-form-field appearance="standard">
        <mat-label>Asset Type</mat-label>
        <mat-select
          [value]="assetTypeFilter"
          (selectionChange)="onAssetTypeChange($event.value)"
        >
          <mat-option *ngFor="let type of assetTypes" [value]="type">
            {{ type }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="standard">
        <mat-label>Filter</mat-label>
        <input
          matInput
          (keyup)="applyFilter($event)"
          placeholder="search by asset id, employee, status..."
          #input
        />
      </mat-form-field>

      <mat-button-toggle-group
        class="status-toggle-group"
        [value]="statusFilter"
        (change)="loadAssets($event.value)"
        aria-label="Asset status filter"
      >
        <mat-button-toggle value="Active">Active</mat-button-toggle>
        <mat-button-toggle value="Inactive">Inactive</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="table-responsive">
      <div *ngIf="loading" class="loading-placeholder">
        Loading assets, please wait...
      </div>
      <div *ngIf="pageLoading" class="table-loading-overlay">
        <mat-progress-spinner
          diameter="40"
          mode="indeterminate"
        ></mat-progress-spinner>
      </div>
      <table
        *ngIf="!loading"
        mat-table
        [dataSource]="dataSource"
        class="mat-elevation-z8"
      >
        <ng-container matColumnDef="assetId">
          <th mat-header-cell *matHeaderCellDef>Asset ID</th>
          <td mat-cell *matCellDef="let element">{{ element.assetId }}</td>
        </ng-container>

        <ng-container matColumnDef="assetType">
          <th mat-header-cell *matHeaderCellDef>Asset Type</th>
          <td mat-cell *matCellDef="let element">{{ element.assetType }}</td>
        </ng-container>

        <ng-container matColumnDef="assetAssignedToEmp">
          <th mat-header-cell *matHeaderCellDef>Assigned To</th>
          <td mat-cell *matCellDef="let element">
            {{ element.assetAssignedToEmp }}
          </td>
        </ng-container>

        <ng-container matColumnDef="mobileNumber">
          <th mat-header-cell *matHeaderCellDef>Mobile Number</th>
          <td mat-cell *matCellDef="let element">{{ element.mobileNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="car">
          <th mat-header-cell *matHeaderCellDef>Car Registration Number</th>
          <td mat-cell *matCellDef="let element">{{ element.car }}</td>
        </ng-container>

        <ng-container matColumnDef="electronicDevice">
          <th mat-header-cell *matHeaderCellDef>
            Electronic Device - Model/Serial Number
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.electronicModel }}
            {{ element.electronicSerialNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef>Price</th>
          <td mat-cell *matCellDef="let element">{{ element.price }}</td>
        </ng-container>

        <ng-container matColumnDef="fuelCard">
          <th mat-header-cell *matHeaderCellDef>Fuel Card</th>
          <td mat-cell *matCellDef="let element">{{ element.fuelCard }}</td>
        </ng-container>

        <ng-container matColumnDef="comments">
          <th mat-header-cell *matHeaderCellDef>Comments</th>
          <td mat-cell *matCellDef="let element">{{ element.comments }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="
            let row;
            columns: displayedColumns;
            trackBy: trackByAssetId
          "
        ></tr>
      </table>

      <mat-paginator
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
    </div>
  </div>
</div>
